import { getService, getAxiosHeaders } from "../../library/RestAPI";
import { put, takeEvery } from "redux-saga/effects";
import { domain_vizr, GET_WEEKLY_STATUS_HEADER, WEEKLY_STATUS_LOADER, GET_WEEKLY_STATUS_HEADER_DATA, GET_WEEKLY_STATUS_HEADER_URL } from "../../redux/constants/constants";

function* getWeeklyHeading(action) {
  yield put({ type: WEEKLY_STATUS_LOADER, payload: true });
  const options = {
    method: "GET",
    url: domain_vizr + `${GET_WEEKLY_STATUS_HEADER_URL}`,
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      yield put({ type: GET_WEEKLY_STATUS_HEADER_DATA, payload: res.data });
      yield put({ type: WEEKLY_STATUS_LOADER, payload: false });
    } else {
      yield put({ type: WEEKLY_STATUS_LOADER, payload: false });
    }
  } catch (err) {
    yield put({ type: WEEKLY_STATUS_LOADER, payload: false });
    console.log(err);
  }
}

function* governorWeeklySaga() {
  yield takeEvery(GET_WEEKLY_STATUS_HEADER, getWeeklyHeading);
}

export default governorWeeklySaga;
